import { Component, Input, OnInit, Output, AfterViewInit, OnDestroy } from '@angular/core';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common';
import { OddModel } from '@app/models/odd.model';

@Component({
  selector: 'outrights-component',
  templateUrl: '../sharedTemplates/Outrights.component.html',
})
export class OutrightsComponent implements OnInit, AfterViewInit, OnDestroy {
  tournamentId = 0;
  @Input() set setTournament(e) {
    this.tournamentId = e;
    this.getOutrightMatchOdds(e);
  }
  @Input() set setTournamentLegacy(e) {
    this.tournamentId = e;
    this.getOutrightMatchOddsLegacy(e);
  }

  sportId = 0;
  outrightSportsList = [];
  outrightCategoriesList = [];
  outrightEventsList = [];
  outrightMatchList = [];
  outrightMatchOddsList = [];
  _selectedOdds: OddModel[] = [];
  tourid;

  defaultRowOpened = false;

  constructor(
    private _UiHelper: UiHelper,
    private _ApiService: ApiService,
    private _route: ActivatedRoute,
    private _router: Router,
    public _UserHelper: UserHelper,
    public _LocalizationService: LocalizationService,
    public _DataHelper: DataHelper,
    public _MatDialog: MatDialog,
    private _location: Location
  ) {}

  private subscriptionsToStopOnDestroy: Subscription[] = [];

  ngOnInit() {
    // console.warn('tOutrightsComponent-tournamentId', this.tournamentId);
    if (this.tournamentId === 0) {
      this._route.params.subscribe(params => {
        this.tourid = params['tourid'];

        this.getOutrightMatchOddsLegacy(this.tourid);
      });
    } else {
      //this.tourid = this.tournamentId;
      //this.getOutrightMatchOdds(this.tourid);
    }

    this._UiHelper.setLoadingDialog(false);
  }

  ngAfterViewInit() {
    this._UiHelper.setLoadingDialog(false);
    this._UiHelper.setNavbarTitle('Outrights', true);

    this.subscriptionsToStopOnDestroy.push(
      this._ApiService.selectedOddsEvent.subscribe(x => {
        this._selectedOdds = x as OddModel[];
      })
    );
    this._UiHelper.setLoadingDialog(false);
  }

  getOutrightSports() {
    this._ApiService.getOutrightSports().then(OutrightSports => {
      //////console.log("OutrightSports", OutrightSports);
      this.outrightSportsList = OutrightSports;

      if (this._UiHelper.leftMenu) this._UiHelper.setLeftMenu();
    });
  }

  getOutrightCategories(sportId) {
    this._UiHelper.setLoadingDialog(true);
    this.sportId = sportId;
    this._ApiService.getOutrightCategories(sportId).then(OutrightCategories => {
      //////console.log("OutrightCategories", OutrightCategories);
      this.outrightCategoriesList = OutrightCategories;
      this._UiHelper.setLoadingDialog(false);
    });
    this._UiHelper.setLoadingDialog(false);
  }

  getOutrightEvents(categoryId, sportId) {
    this._UiHelper.setLoadingDialog(true);
    this._ApiService.getOutrightEvents(categoryId, sportId).then(OutrightEvents => {
      //////console.log("OutrightEvents", OutrightEvents);
      this.outrightEventsList = OutrightEvents;
      this._UiHelper.setLoadingDialog(false);
    });
    this._UiHelper.setLoadingDialog(false);
  }

  //getOutrightMatch(matchId) {
  //  this._ApiService.getOutrightMatch(matchId).then((OutrightMatch) => {
  //    ////console.log("OutrightMatch", OutrightMatch);
  //    this.outrightMatchList = OutrightMatch;
  //    this.getOutrightMatchOdds(matchId);
  //  });
  //}

  public getOutrightMatchOdds(matchId) {
    this._UiHelper.setLoadingDialog(true);
    this._ApiService.getOutrightMatchOddsbyTourId(matchId).then(OutrightMatchOdds => {
      // console.warn('OutrightMatchOdds', OutrightMatchOdds);
      this.outrightMatchOddsList = OutrightMatchOdds;
      this._UiHelper.setLoadingDialog(false);
    });
    this._UiHelper.setLoadingDialog(false);
  }

  public getOutrightMatchOddsLegacy(matchId) {
    this._UiHelper.setLoadingDialog(true);
    this._ApiService.getOutrightMatchOdds(matchId).then(OutrightMatchOdds => {
      // console.warn('OutrightMatchOdds', OutrightMatchOdds);
      this.outrightMatchOddsList = OutrightMatchOdds;
      this._UiHelper.setLoadingDialog(false);

      this.defaultRowOpened = true;
    });
  }

  clickOdd(OddId) {
    this._ApiService.addOutrightsOdd(OddId);
  }

  checkOddId(oddId) {
    //////console.log("oddd (2)", oddId);
    const index = this._ApiService.slipCurrents.findIndex(v => {
      return v.OddId1 == oddId;
    });
    if (index > -1) {
      return 'outrights-button-active';
    } else {
      return '';
    }
  }
  goBack() {
    this._location.back();
    // console.warn("back clicked")
    // this._router.navigate(['/home']);
    // this._router.navigate(['/home']);
  }
  ngOnDestroy(): void {
    for (const subscription of this.subscriptionsToStopOnDestroy) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
  }

  groupName = '';
  openOutrightsRow(e) {
    if (e.GroupName === this.groupName) {
      this.groupName = '';
    } else {
      this.groupName = e.GroupName;
    }
  }
}
